module.exports = __webpack_public_path__ + "static/media/building.afd76a81.jpg";